import { RunMode } from './run-modes.enum';

export const environment = {
  production: false,
  apiBaseUrl: 'https://api-router.pilot.theprincipal.net:9003/transaction-service-ext',
  runMode: RunMode.Production,
  authority: 'https://accounts.staging.principal.com/oauth2/aus4nvp00mFyV36By697',
  clientId: 'X3HYWgbJSYnVdR1CgCL6auABmhXHfWNx',
  scope: 'openid profile offline_access appGroups api://nq/graphql/ppm.plan.read-only',
  graphqlUrl: 'https://api.usis-nq-ppm.staging.principalaws.com/graphql',
};
